import React from "react";
import { Form, Input } from "antd";
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

export default class AntDMultipleTextBoxWrapper extends React.Component {
  id = 0;
  state = {
    data: [],
    oneTimeSetData: true,
  };

  componentDidMount() {
    this.setData();
  }

  setData = () => {
    if (this.props.editDataAvailable) {
      this.props.formRef.current.setFieldsValue({
        [this.props.decorator]: this.props.editFormData[this.props.decorator],
      });
      let data = [...this.props.editFormData[this.props.decorator]];
      data = data.map((item) => {
        item.id = this.id++;
        return item;
      });

      if (this.props.handleChange) {
        this.props.handleChange(this.props.decorator, data);
      } else {
        this.setState({
          oneTimeSetData: false,
          data: data,
        });
      }
    } else {
      this.add();
    }
  };

  handleChange = (event) => {
    let form = this.props.formRef.current;
    let state = this.getValue();
    for (let i = 0; i < state.length; i++) {
      if (state[i].id.toString() === event.target.id) {
        state[i].value = event.target.value;
      }
    }
    form.setFieldsValue({
      [this.props.decorator]: state,
    });
    if (this.props.handleChange) {
      this.props.handleChange(this.props.decorator, state);
    } else {
      this.setState({ data: state });
    }
  };

  remove = (k) => {
    let form = this.props.formRef.current;
    if (this.getValue().length === 1) {
      return;
    }
    let newKeys = this.getValue().filter((d) => d.id !== k.id);
    form.setFieldsValue({ [this.props.decorator]: newKeys });
    if (this.props.handleChange) {
      this.props.handleChange(this.props.decorator, newKeys);
    } else {
      this.setState({ data: newKeys });
    }
  };

  add = () => {
    if (this.getValue().length > 4 || this.props.disabled) {
      return;
    }
    let form = this.props.formRef.current;
    let data = [...this.getValue()];
    if (
      form !== null &&
      form.getFieldValue(this.props.decorator) !== undefined
    ) {
      data = form.getFieldValue(this.props.decorator);
    }
    let nextKeys = data.concat({ id: Math.floor(Math.random() * (9999 - 101) + 101), value: "" });

    if (form !== null) {
      form.setFieldsValue({ [this.props.decorator]: nextKeys });
    }

    if (this.props.handleChange) {
      this.props.handleChange(this.props.decorator, nextKeys);
    } else {
      this.setState({ data: nextKeys });
    }
  };

  getValue = () => {
    return this.props.formData
      ? this.props.formData[this.props.decorator]
      : this.state.data;
  };

  render() {
    if (this.props.editDataAvailable && this.state.oneTimeSetData) {
      this.setData();
    }

    const formItems = this.getValue().map((k, index) => (
      <Form.Item
        name={k.id}
        label={index === 0 ? this.props.label : ""}
        required={this.props.required}
        key={k.id}
        validateTrigger={["onBlur"]}
        rules={[]}
      >
        <Input
          id={k.id}
          value={k.value}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          maxLength={this.props.maxlength}
          placeholder={this.props.placeholder}
          className="multiple-control"
        />
        {this.getValue().length > 0 ? (
          this.props.disableControls || this.props.disabled ? (
            <EyeOutlined className="operationPlusMinus" />
          ) : (
            <PlusCircleOutlined
              className="operationPlusMinus"
              onClick={() => this.add()}
            />
          )
        ) : null}
        &nbsp;&nbsp;
        {this.getValue().length > 1 ? (
          this.props.disableControls || this.props.disabled ? (
            <EyeOutlined className="operationPlusMinus" />
          ) : (
            <MinusCircleOutlined
              className="operationPlusMinus"
              onClick={() => this.remove(k)}
            />
          )
        ) : null}
      </Form.Item>
    ));

    return (
      <div>
        <Form.List
          name={this.props.decorator}
          rules={[
            ...this.props.validators,
            {
              required: this.props.required,
              message: this.props.message,
            }
          ]}
        >
          {(fields, { add, remove }) => {
            return <div>{formItems}</div>;
          }}
        </Form.List>
      </div>
    );
  }
}
